<template>
  <div class="myUnderstand_wrap  chinese_container">
    <myHeader />
    <div class="content" id="myUnderstand_content">
      <!-- 文本模块 -->
      <div class="understand_text">
        <div class="layout_text">
          <p class="wow fadeInUp" style="color: #b3b3b3; font-size: 24px">
            什么是2.5D?
          </p>
          <p class="wow fadeInUp" style="font-size: 48px; margin: 20px 0 60px">
            了解2.5D如何让项目栩栩如生
          </p>
          <p
            class="default_font wow fadeInUp"
            style="font-size: 20px; font-weight: 400; line-height: 30px"
          >
            所谓2.5D指将2D与3D资产结合的一种场景资产构建方式，<br />用多层带透明通道的图片/动态场景内容组合表现近、中、远景（多层）不同层次景别的场景元素。<br />在拍摄一些摄影机特定运镜路线的镜头时，相比制作纯3D场景，2.5D的场景制作难度大幅降低且适配原有的三维工作流程。<br />对劳动密集型3D场景搭建的团队来说，是更经济、更高效的替代方案。
          </p>
          <p
            class="wow fadeInUp"
            style="color: #fff; font-size: 24px; margin: 40px 0 50px"
          >
            叠加渲染输出
          </p>
        </div>
      </div>
      <div class="layout_text">
        <div class="img wow fadeInUp">
          <img style="width: 100%" src="https://download.hecoos.com/enlightv/2025-17/b6cf8fdfe1dd71abde278bc0ff977fdb.png" alt="" />
        </div>
      </div>

      <!-- 位置关系模块 -->
      <div class="layout_text">
        <div class="position_module">
          <p
            class="wow fadeInUp"
            style="color: #fff; font-size: 24px; margin: 40px 0 60px"
          >
            摄影机运动过程中不同景别的位置关系
          </p>
          <img
            style="width: 100%; margin-bottom: 50px"
            class="wow fadeInUp"
            src="https://download.hecoos.com/enlightv/2025-17/609dde8ae74ce6247067775d338ace9d.png"
            alt=""
          />
          <img
            class="wow fadeInUp"
            style="width: 100%"
            src="https://download.hecoos.com/enlightv/2025-17/5175ff6161aabf86f6b983bf95ed54e6.png"
            alt=""
          />
        </div>
      </div>

      <!-- AIGC模块 -->
      <div class="layout_text">
        <div class="aigc_module">
          <div class="aigc">
            <div class="aigc_text">
              <p
                class="wow fadeInUp"
                style="color: #fff; font-size: 48px; margin: 0 0 10px"
              >
                AIGC + 2.5D
              </p>
              <p
                class="wow fadeInUp"
                style="color: #fff; font-size: 36px; margin: 0 0 30px"
              >
                全面提升虚拟拍摄中的场景搭建效率
              </p>
              <p class="wow fadeInUp" style="font-size: 18px">
                将通过AIGC生成的2D场景图片 / 动态场景内容分割解构再重组合成2.5D
                的分层场景资产进入hecoos xR/VP进行现场拍摄
              </p>
            </div>
          </div>
          <img
            class="wow fadeInUp"
            style="width: 100%"
            src="https://download.hecoos.com/enlightv/2025-17/0a5e958a0e994e2674250d8115e2decd.png"
            alt=""
          />
        </div>
      </div>

      <!-- 快~~模块 -->
      <div class="layout_text">
        <div class="fast_module">
          <div class="fast_left">
            <img
              class="wow fadeInUp"
              width="3%"
              style="margin-bottom: 24px"
              src="https://download.hecoos.com/enlightv/2025-17/89a7106ac2dfbc5930a584a7ffbbd1d1.png"
              alt=""
            />
            <p class="wow fadeInUp" style="color: #b3b3b3; font-size: 24px">
              快
            </p>
            <p
              class="wow fadeInUp"
              style="color: #fff; font-size: 48px; margin: 14px 0 20px"
            >
              犀利一如
            </p>
            <p class="wenB wow fadeInUp">
              hecoos xR/VP
              2.5D拍摄方案用户无论是在前期创意制作还是在摄制过程中，可借助AIGC的内容生成能力快速更改和调整虚拟场景（不完全依赖三维资产团队），在几分钟内由概念形成具体的镜头场景，从而实现更灵活高效、更具成本效益的创作过程。
            </p>
            <img
              class="wow fadeInUp"
              style="width: 80%"
              src="https://download.hecoos.com/enlightv/2025-17/44f416980b378e5e3a5877efafa856b6.png"
              alt=""
            />
          </div>
          <div class="fast_rig">
            <img
              class="wow fadeInUp"
              width="5%"
              style="margin-bottom: 24px"
              src="https://download.hecoos.com/enlightv/2025-17/49d11a36b1591c6e90891e75e8d806c9.png"
              alt=""
            />
            <p class="wow fadeInUp" style="color: #b3b3b3; font-size: 24px">
              快
            </p>
            <p
              class="wow fadeInUp"
              style="color: #fff; font-size: 48px; margin: 14px 0 20px"
            >
              主打一个行动力
            </p>
            <p class="wenB wow fadeInUp">
              hecoos xR/VP
              2.5D拍摄方案使用图片/动态内容作为拍摄场景，不再依赖3D实时渲染所带来的高额算力需求，对于渲染服务器硬件的要求大大降低（甚至无需渲染服务器）。
            </p>
            <img
              class="wow fadeInUp"
              style="width: 80%"
              src="https://download.hecoos.com/enlightv/2025-17/ff121c939c5b6ceaf87334996c109a5d.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <myFooter />w
    <BackToTop></BackToTop>
  </div>
</template>

<script>
import myHeader from "@/components/pc/myHeader.vue";
import myFooter from "@/components/pc/myFooter.vue";
import BackToTop from "@/components/pc/BackToTop";
export default {
  components: {
    myHeader,
    myFooter,
    BackToTop,
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/xty.scss";
@import "@/styles/optimize_adaptation.scss";
</style>
